import { createSlice } from "@reduxjs/toolkit";

export const signoSlice = createSlice({
  name: "signoMoneda",
  initialState: {},
  reducers: {
    signoAdd: (state, action) => {
      
      return action.payload;
    },
  },
});

export const { signoAdd } = signoSlice.actions;
export default signoSlice.reducer;

